import { render, staticRenderFns } from "./OcrReviewModal.vue?vue&type=template&id=2ae6de62&scoped=true"
import script from "./OcrReviewModal.vue?vue&type=script&lang=js"
export * from "./OcrReviewModal.vue?vue&type=script&lang=js"
import style0 from "./OcrReviewModal.vue?vue&type=style&index=0&id=2ae6de62&prod&lang=css"
import style1 from "./OcrReviewModal.vue?vue&type=style&index=1&id=2ae6de62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae6de62",
  null
  
)

export default component.exports